import { Button, Tooltip } from 'flowbite-react';
import { useEffect, useState } from 'react';
import AssetListTable from './AssetListTable';
import { toast } from 'react-toastify';
import Loader from '../Common/Loader';
import { useAppSelector } from '../../Reducers/store';
import { useParams } from 'react-router-dom';
import { Asset } from '../../Models/Asset';
import AssetApi from '../../Api/AssetApi';
import { HiPlus } from 'react-icons/hi';
import AddAssetModal from './AddAssetModal';

export default function AssetList() {
  const { id } = useParams();
  const { userModel } = useAppSelector((state) => state.user);
  const [assetListData, setassetListData] = useState<Asset[]>([]);
  const [selectedAsset, setselectedAsset] = useState<Asset | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showAddAsset, setshowAddAsset] = useState<boolean>(false);

  useEffect(() => {
    getAssetList();
  }, [userModel]);

  const getAssetList = () => {
    if (userModel) {
      try {
        setIsLoading(true);
        return AssetApi.getAssetList()
          .then((res) => {
            setassetListData(res.data);

            setIsLoading(false);
          })
          .catch((err) => {
            toast.error('Error');
            setIsLoading(false);
          });
      } catch (error) {
        console.error(error);
        toast.error('Error');
        setIsLoading(false);
      }
    }
  };

  const handleAssetClick = () => {
    setshowAddAsset(true);
  };

  const editAsset = (Asset: Asset) => {
    setselectedAsset(Asset);
    setshowAddAsset(true);
  };

  function deleteAsset(id: number) {
    const shouldRemove = window.confirm(
      'Are you sure you want to delete this?'
    );

    if (shouldRemove) {
      AssetApi.deleteAsset(id)
        .then((res) => {
          if (res.data.success) {
            toast.success(res.data.message);
            getAssetList();
          } else {
            toast.success('Error while deleting item');
          }
        })
        .catch((err) => {
          toast.error('Error: ' + err);
        });
    }
  }

  function checkAccess() {
    // if (userModel && userModel.userLevelId === UserLevelNames.SuperAdmin) {
    if (userModel) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <>
      <div className='w-full'>
        <div className='w-full h-[74px] p-4'>
          <div className='mx-1 flex items-end'>
            <div className='flex flex-1'>
              <h1 className='text-gray-900 font-bold text-4xl'>
                <div>Asset List</div>
              </h1>
            </div>
            {checkAccess() && (
              <div className=''>
                <Tooltip content='Add Asset'>
                  <Button onClick={handleAssetClick} className='buttonMain'>
                    <HiPlus size={20} />
                  </Button>
                </Tooltip>
              </div>
            )}
          </div>
        </div>
        <div className='w-full p-4 h-[calc(100vh-132px)] md:h-[calc(100vh-200px)] overflow-y-auto'>
          {isLoading && <Loader />}
          <AssetListTable
            data={assetListData}
            editAsset={editAsset}
            deleteAsset={deleteAsset}
          />
        </div>
      </div>
      <AddAssetModal
        show={showAddAsset}
        setShow={setshowAddAsset}
        selectedAsset={selectedAsset}
        getAssetList={getAssetList}
        setselectedAsset={setselectedAsset}
      />
    </>
  );
}
